export default {"src":"/_next/static/media/phone_white_outline_40.6a8b2603.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};